import React from 'react'
import { observer } from 'mobx-react-lite'

import { ImportScreen } from '../../ImportScreen'
import { OzonProductImportTable } from '../../OzonProductImportTable'

import { useOzonAccount } from '../../../hooks/routeHooks'
import { useApi, useStore } from '../../../hooks/storeHook'

import { OzonProductsTableData } from '../../../store/productStore'

import { OzonProductColumnId } from '../../../types/ozonColumns'
import { OzonAccountModel } from '../../../server/mpsklad_core/Models/OzonAccountModel'
import { OzonProductModel } from '../../../server/mpsklad_core/Models/OzonProductModel'
import { OzonProductsTableFilterColumn } from '../../../server/mpsklad_core/Models/OzonProductsTableFilterColumn'

export const OzonImportPage =
  observer(() => {
    const api = useApi()
    const {productStore: {createOzonProductsTable}} = useStore()
    const account = useOzonAccount()

    const products = createOzonProductsTable(account.id).setPropFilterReadOnly('hasMsProduct', true)

    return (
      <ImportScreen<OzonAccountModel, OzonProductsTableData, OzonProductModel, OzonProductColumnId, typeof OzonProductsTableFilterColumn>
        type="Ozon"
        account={account}
        products={products}
        addProductsFunc={api.import.importProductsOzon}
        updateProductsFunc={api.import.updateProductsOzon}
        importStocksFunc={api.import.importStocksOzon}
        TableComponent={OzonProductImportTable}
      />
    )
  })